import { newselaLayoutTargets } from './layoutTargets';
import { preview } from './preview';

export const Newsela = {
  layoutTargets: newselaLayoutTargets,
  preview,
};
